import { render } from "./CardRectangle.vue?vue&type=template&id=0b061b40&scoped=true"
import script from "./CardRectangle.vue?vue&type=script&lang=js"
export * from "./CardRectangle.vue?vue&type=script&lang=js"

import "./CardRectangle.vue?vue&type=style&index=0&id=0b061b40&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b061b40"]])

export default __exports__